import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  TablePagination,
  TableFooter,
} from '@mui/material'
import type { FC } from 'react'

import Error from '@/components/UI/Table/Error'
import NoResults from '@/components/UI/Table/NoResults'
import type { TransformedData } from '@/lib/apollo/query/getActivitiesForUser'

import Loading from './Loading'
import PageRows from './PageRows'
import { rowHeight, rowsPerPage } from './utils'

export type Props = {
  errorMessage?: string
  loading?: boolean
  data?: TransformedData
  page: number
  onChangePage: (newPage: number) => void
}

const ActivityTable: FC<Props> = ({
  data,
  errorMessage,
  loading = false,
  page,
  onChangePage,
}) => {
  const handleChangePage = (
    _: React.MouseEvent<HTMLButtonElement> | null,
    newPage: number,
  ) => {
    onChangePage(newPage)
  }

  return (
    <TableContainer>
      <Table aria-label="simple table" size="small">
        <TableHead>
          <TableRow>
            <TableCell>
              <Typography variant="subtitle2">Activity</Typography>
            </TableCell>
            <TableCell width={100}>
              <Typography variant="subtitle2">Type</Typography>
            </TableCell>
            <TableCell width={100}>
              <Typography variant="subtitle2">Section</Typography>
            </TableCell>
            <TableCell width={140}>
              <Typography variant="subtitle2">Date/ Time</Typography>
            </TableCell>
            <TableCell width={110}></TableCell>
          </TableRow>
        </TableHead>
        <TableBody sx={{ height: rowHeight * rowsPerPage }}>
          {errorMessage ? (
            <Error colSpan={5} errorMessage={errorMessage} />
          ) : loading || data === undefined ? (
            <Loading test-id="activity-table-loading" />
          ) : data.results.length === 0 ? (
            <NoResults colSpan={5} />
          ) : (
            <PageRows data={data.results} />
          )}
        </TableBody>
        <TableFooter>
          <TableRow>
            <TablePagination
              rowsPerPageOptions={[rowsPerPage]}
              colSpan={5}
              count={data?.total ?? 0}
              rowsPerPage={rowsPerPage}
              page={page}
              onPageChange={handleChangePage}
            />
          </TableRow>
        </TableFooter>
      </Table>
    </TableContainer>
  )
}

export default ActivityTable
